
var translations = { root: require("./CardDetails.js?raw=true"),"es": require("./es/CardDetails.js?raw=true"),"es-formal": require("./es-formal/CardDetails.js?raw=true") };
var env = typeof window !== "undefined" ? "browser" : "node";
var loc = env === "browser" && (window.locale || navigator.language || navigator.userLanguage) || global.locale;
var translation = loc && (translations[loc] || translations[loc.substr(0, 2)]) || translations["root"];
module.exports = translation;